module.exports = __webpack_public_path__ + "img/newsBg.a0d18d16.png";